import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'shared/theme';
import AppRouter from './appRouter';
import { QueryClientProvider } from 'react-query';
import './index.css';
import './osano.css';
import ToastContainer from 'components/Toast/ToastContainer';
import { ReactQueryDevtools } from 'react-query/devtools';
import { FeatureFlagProvider } from 'feature-flags';
import { getQueryClient } from 'query-client';
import { ModalProvider } from 'context/ModalContext';
import { initializeTrackingScripts } from 'shared/util/trackingScripts';
import { BrandProvider } from 'context/BrandProvider';
import { getBrandFromS3 } from 'api/brand/api';

initializeTrackingScripts();
const queryClient = getQueryClient();

const bootstrapApp = async () => {
  const brand = await getBrandFromS3();

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  root.render(
    <StrictMode>
      <BrandProvider brand={brand}>
        <ModalProvider>
          <FeatureFlagProvider>
            <ThemeProvider>
              <QueryClientProvider client={queryClient}>
                <AppRouter />
                <ReactQueryDevtools initialIsOpen={false} />
                <ToastContainer />
              </QueryClientProvider>
            </ThemeProvider>
          </FeatureFlagProvider>
        </ModalProvider>
      </BrandProvider>
    </StrictMode>,
  );
};

bootstrapApp();
